<script setup>
import { router, useForm } from '@inertiajs/vue3';
import JetActionMessage from '@/Jetstream/ActionMessage.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetFormSection from '@/Jetstream/FormSection.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetLabel from '@/Jetstream/Label.vue';
import { ref } from 'vue';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';
// Get locale as set in cookie
let { locale } = useI18n({ useScope: 'global' });
// This needs removing before pushing.

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const props = defineProps({
    team: Object,
    permissions: Object,
});

let team_custom_name = programme.team_custom_name;
if (team_custom_name) {
    if(team_custom_name.constructor.name != 'Object') {
        team_custom_name = JSON.parse(team_custom_name);
    }
}

let default_team_name;

if (locale.value == 'cy') {
    default_team_name = 'tîm';

} else  {
    default_team_name = 'team';
}

let team_name = default_team_name;

if (team_custom_name) {
    team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
}


const form = useForm({
    carbon_savings: props.team.enable_carbon_savings,
    team_id: props.team.id
});

const updateCarbonSetting = () => {
    //form.post(route(urlNamePrefix+'teams.update-carbon', props.team), {
    form.post(route(urlNamePrefix+'teams.update-carbon'), {
        errorBag: 'updateCarbonSetting',
        preserveScroll: true,
    });
};

</script>

<template>
    <JetFormSection @submitted="updateCarbonSetting">
        <template #title>
            <span style="text-transform: capitalize;">{{ $t('teams.carbon_savings.title', { team_name: team_name }) }}</span>
        </template>

        <template #description>
            {{ $t('teams.carbon_savings.description', { team_name: team_name }) }}
        </template>

        <template #form>
            <!-- Carbon Savings -->
            <div class="flex content-center justify-center col-span-6 sm:col-span-4">
                <input
                    id="carbon_savings"
                    type="checkbox"
                    v-model="form.carbon_savings"
                    :true-value="1"
                    :false-value="0"
                    class="mb-5 mr-5 border-gray-300 rounded-md shadow-sm action-custom-field focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                />
                <JetLabel for="carbon_savings" :value="$t('teams.carbon_savings.toggle', { team_name: team_name })" />

                <JetInputError :message="form.errors.carbon_savings" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <JetActionMessage :on="form.recentlySuccessful" class="mr-3">
                {{ $t('teams.carbon_savings.success') }}
            </JetActionMessage>

            <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{ $t('teams.carbon_savings.submit') }}
            </JetButton>
        </template>
    </JetFormSection>
</template>
